import { render } from "./EnBadge.vue?vue&type=template&id=1a71e778&scoped=true&ts=true"
import script from "./EnBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnBadge.vue?vue&type=script&setup=true&lang=ts"

import "./EnBadge.vue?vue&type=style&index=0&id=1a71e778&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a71e778"],['__file',"Shared/components/base/EnBadge/EnBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a71e778"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a71e778', __exports__)) {
    api.reload('1a71e778', __exports__)
  }
  
  module.hot.accept("./EnBadge.vue?vue&type=template&id=1a71e778&scoped=true&ts=true", () => {
    api.rerender('1a71e778', render)
  })

}


export default __exports__